/**
 * @description editor 插件，重写 editor API
 */
import {
  SlateEditor,
  SlateTransforms,
  SlatePoint,
  SlateNode,
  DomEditor,
} from "@wangeditor/editor";
import { ELEMENT_TYPE } from "./constants";
import { Editor, Transforms } from "slate";
function withMarkBlock(editor) {
  const { insertBreak, insertText, normalizeNode, deleteBackward } = editor;
  const newEditor = editor;
  // 重写删除
  newEditor.deleteBackward = (unit) => {
    const selection = editor.selection;
    if (selection == null) return deleteBackward(unit);
    const [nodeEntry] = SlateEditor.nodes(editor, {
      match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
      universal: true,
    });
    if (!nodeEntry) return deleteBackward(unit);
    const offset = selection.focus.offset;
    const path = selection.focus.path;
    if (offset === 0 && path[path.length - 1] === 0) {
      return;
    } else {
      deleteBackward(unit);
    }
    // const quoteElem = nodeEntry[0];
    // // 获取children
    // const quotePath = DomEditor.findPath(editor, quoteElem);
    // console.log(DomEditor.getNodeType(quoteElem));
    // const quoteStartLocation = SlateEditor.start(editor, quotePath);

    // if (SlatePoint.equals(quoteStartLocation, selection.focus)) {
    //   // // 光标位于 元素的 最开始
    //   return;
    // } else {
    //   deleteBackward(unit);
    // }
  };
  // 插入节点
  // newEditor.insertNode = (elem) => {
  //   // console.log("insertNode》〉》〉》〉》〉》〉》〉》〉》〉》〉》〉》〉", elem);
  // };
  // 重新 normalize
  newEditor.normalizeNode = ([node, path]) => {
    const type = DomEditor.getNodeType(node);
    if (type !== ELEMENT_TYPE) {
      // 未命中  执行默认的 normalizeNode
      return normalizeNode([node, path]);
    }

    // --------------   是 editor 最后一个节点，需要后面插入 p --------------
    const isLast = DomEditor.isLastNode(newEditor, node);
    if (isLast) {
      Transforms.insertNodes(newEditor, DomEditor.genEmptyParagraph(), {
        at: [path[0] + 1],
      });
    }
  };
  // 重写 insertText
  newEditor.insertText = (text) => {
    return insertText(text);
    // console.log("insertText》〉》〉》〉》〉》〉》〉》〉》〉》〉》〉》〉", text);

    // const { selection } = newEditor;
    // if (selection == null) return insertText(text);

    // const [nodeEntry] = SlateEditor.nodes(editor, {
    //   match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
    //   universal: true,
    // });
    // if (!nodeEntry) return insertText(text);
    // // 限制文本长度
    // // 获取当前类型输入的文字
    // const quoteElem = nodeEntry[0];
    // const quotePath = DomEditor.findPath(editor, quoteElem);
    // const str = SlateNode.string(quoteElem);
    // console.log("str", str);
    // const couldInsert = 500 - str.length;
    // console.log("couldInsert", couldInsert);
    // if (couldInsert <= 0) {
    //   // 禁止输入
    //   console.log("来喝了吧", 99999);
    //   // 删除光标后面的文字
    //    insertText('')
    //    editor.deleteBackward()

    // } else {
    //   return insertText(text);
    // }
  };

  // 重写 insertBreak - 换行时插入 p
  newEditor.insertBreak = () => {
    // console.log("insertBreak》〉》〉》〉》〉》〉newEditor", newEditor);

    const { selection } = newEditor;
    // console.log("selection", selection);
    if (selection == null) return insertBreak();
    const [nodeEntry] = SlateEditor.nodes(editor, {
      match: (n) => DomEditor.checkNodeType(n, ELEMENT_TYPE),
      universal: true,
    });
    if (!nodeEntry) return insertBreak();
    const quoteElem = nodeEntry[0];
    const qaPosition = selection.focus.path[0];
    const linePosition = selection.focus.path[1];
    if (linePosition === 0) {
      const secondElement = quoteElem.children[1];
      const length = secondElement.children[0].text.length;
      // 在’问‘一行
      return editor.select({
        anchor: { path: [qaPosition, 1, 0], offset: length },
        focus: { path: [qaPosition, 1, 0], offset: length },
      });
    } else if (linePosition === 1) {
      // 在’答‘一行
      const quotePath = DomEditor.findPath(editor, quoteElem);
      const quoteEndLocation = SlateEditor.end(editor, quotePath);
      if (SlatePoint.equals(quoteEndLocation, selection.focus)) {
        const p = { type: "paragraph", children: [{ text: "" }] };
        SlateTransforms.insertNodes(newEditor, p, { mode: "highest" });
      }
    }
  };
  // 重新粘贴
  // newEditor.insertData = (data) => {
  //   console.log("insertData", data);
  // };

  return newEditor;
}
export default withMarkBlock;
